import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {ConversionLibraryPage} from './conversion-library';

const routes: Routes = [
  { path: '', component: ConversionLibraryPage },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ConversionLibraryPageRoutingModule {}
